<div class="experience-scope" [attr.data-theme]="theme">
  <div class="home-experience">
    <header class="home-experience__topbar">
      <div class="logo-mark" title="Cimalti">
        <img
          src="../../../../../assets/images/logo-min-white.svg"
          alt="Cimalti"
        />
      </div>
      <div class="home-experience__brand">
        <div class="home-experience__brand-name">Cimalti</div>
        <div class="home-experience__brand-sub">Portfolios · 2026</div>
      </div>
      <div class="home-experience__spacer"></div>
      <button
        class="btn btn-ghost btn-sm exit-btn"
        type="button"
        (click)="backToHome()"
        title="Back to home"
      >
        <svg
          viewBox="0 0 24 24"
          width="14"
          height="14"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
        >
          <path d="M19 12H5" />
          <path d="M12 19l-7-7 7-7" />
        </svg>
        <span>Home</span>
      </button>
      <button
        class="icon-btn"
        type="button"
        (click)="toggleTheme()"
        [title]="theme === 'dark' ? 'Switch to light' : 'Switch to dark'"
      >
        @if (theme === "dark") {
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            width="17"
            height="17"
          >
            <path d="M21 13a9 9 0 11-10-10 7 7 0 0010 10z" />
          </svg>
        }
        @if (theme === "light") {
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            width="17"
            height="17"
          >
            <circle cx="12" cy="12" r="4" />
            <path
              d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"
            />
          </svg>
        }
      </button>
    </header>

    <div class="pflist-wrap">
      <div class="pflist-hero">
        <div>
          <h1>All portfolios</h1>
          <div class="lead">
            {{ all.length }} portfolio
            @if (all.length !== 1) {
              <span>s</span>
            }
            across {{ currencies.length }} currenc
            @if (currencies.length !== 1) {
              <span>ies</span>
            }
            @if (currencies.length === 1) {
              <span>y</span>
            }
            . Click any tile to open it.
          </div>
        </div>
        <div class="pflist-hero-right">
          <button
            class="btn btn-ghost"
            type="button"
            (click)="uploadPortfolio()"
          >
            Upload portfolio
          </button>
          <button
            class="btn btn-primary"
            type="button"
            (click)="newPortfolio()"
          >
            + New portfolio
          </button>
        </div>
      </div>

      <div class="pflist-stats">
        <div class="pflist-stat">
          <div class="lbl">Total portfolios</div>
          <div class="val">{{ all.length }}</div>
          <div class="sub">{{ starredCount }} starred</div>
        </div>
        <div
          class="pflist-stat"
          [class.pos]="totalDelta >= 0"
          [class.neg]="totalDelta < 0"
        >
          <div class="lbl">Avg annualised return</div>
          <div class="val">
            {{ totalDelta >= 0 ? "+" : "" }}{{ totalDelta | number: "1.1-1" }}%
          </div>
          <div class="sub">{{ winners }} of {{ all.length }} in the green</div>
        </div>
        <div class="pflist-stat">
          <div class="lbl">Avg risk (vol)</div>
          <div class="val">{{ avgRisk | number: "1.1-1" }}%</div>
          <div class="sub">across all books</div>
        </div>
        <div class="pflist-stat">
          <div class="lbl">Currencies</div>
          <div class="val">{{ currencies.length }}</div>
          <div class="sub">{{ currencies.join(" · ") || "—" }}</div>
        </div>
      </div>

      <div class="pflist-toolbar">
        <div class="pflist-search">
          <svg viewBox="0 0 24 24">
            <circle cx="11" cy="11" r="7" />
            <path d="M20 20l-3-3" />
          </svg>
          <input
            type="text"
            [(ngModel)]="search"
            (ngModelChange)="onSearch()"
            placeholder="Search by name…"
          />
        </div>
        <div class="pflist-filter-wrap" [class.open]="ccyFilterOpen">
          <button
            class="pflist-filter"
            type="button"
            (click)="toggleCurrencyFilter()"
            [class.active]="ccyFilter.size > 0"
          >
            <span>Currency · {{ currencyFilterLabel }}</span>
            <svg
              class="pflist-filter-caret"
              viewBox="0 0 12 12"
              aria-hidden="true"
            >
              <path
                d="M3 4.5l3 3 3-3"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          @if (ccyFilterOpen) {
            <div class="pflist-filter-menu">
              <div class="pflist-filter-menu-head">
                <span>Filter by currency</span>
                @if (ccyFilter.size) {
                  <button
                    type="button"
                    class="pflist-filter-menu-clear"
                    (click)="clearCurrencyFilter()"
                  >
                    Clear
                  </button>
                }
              </div>
              <div class="pflist-filter-menu-list">
                @for (c of currencies; track c) {
                  <label class="pflist-filter-option">
                    <input
                      type="checkbox"
                      [checked]="ccyFilter.has(c)"
                      (change)="toggleCurrencyOption(c)"
                    />
                    <span>{{ c }}</span>
                  </label>
                }
                @if (!currencies.length) {
                  <div class="pflist-filter-empty">No currencies available</div>
                }
              </div>
            </div>
          }
        </div>
        <div class="pflist-filter-wrap" [class.open]="statusFilterOpen">
          <button
            class="pflist-filter"
            type="button"
            (click)="toggleStatusFilter()"
            [class.active]="statusFilter.size > 0"
          >
            <span>Status · {{ statusFilterLabel }}</span>
            <svg
              class="pflist-filter-caret"
              viewBox="0 0 12 12"
              aria-hidden="true"
            >
              <path
                d="M3 4.5l3 3 3-3"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
          @if (statusFilterOpen) {
            <div class="pflist-filter-menu">
              <div class="pflist-filter-menu-head">
                <span>Filter by status</span>
                @if (statusFilter.size) {
                  <button
                    type="button"
                    class="pflist-filter-menu-clear"
                    (click)="clearStatusFilter()"
                  >
                    Clear
                  </button>
                }
              </div>
              <div class="pflist-filter-menu-list">
                @for (s of statuses; track s) {
                  <label class="pflist-filter-option">
                    <input
                      type="checkbox"
                      [checked]="statusFilter.has(s)"
                      (change)="toggleStatusOption(s)"
                    />
                    <span>{{ s }}</span>
                  </label>
                }
                @if (!statuses.length) {
                  <div class="pflist-filter-empty">No statuses available</div>
                }
              </div>
            </div>
          }
        </div>
        <button class="pflist-filter" type="button" (click)="cycleSort()">
          Sort · {{ sortLabel }}
        </button>
        <div class="pflist-view">
          <button
            type="button"
            [class.active]="view === 'cards'"
            (click)="setView('cards')"
          >
            Cards
          </button>
          <button
            type="button"
            [class.active]="view === 'list'"
            (click)="setView('list')"
          >
            List
          </button>
        </div>
      </div>

      @if (!isLoading && visible.length) {
        <div class="pflist-grid" [class.view-list]="view === 'list'">
          @for (p of visible; track trackByTile(i, p); let i = $index) {
            <a
              class="pf-tile"
              (click)="openPortfolio(p)"
              style="cursor: pointer"
              [style.--tile-i]="i"
            >
              <div class="pf-tile-head">
                <div class="pf-tile-head-main">
                  <div class="pf-tile-name" [title]="p.name">{{ p.name }}</div>
                  <div class="pf-tile-meta">
                    <span
                      class="pf-status"
                      [class.warn]="p.status === 'Computing'"
                      [class.neg]="p.status === 'Failed'"
                    >
                      <span class="dot"></span>{{ p.status }}
                    </span>
                    <span class="sep"></span>
                    <span>{{ p.ccy }}</span>
                    <span class="sep"></span>
                    <span>{{ p.assets }} assets</span>
                  </div>
                </div>
                <button
                  class="pf-tile-star"
                  type="button"
                  [class.on]="p.starred"
                  aria-label="Star"
                  (click)="toggleStar(p, $event)"
                >
                  <svg
                    viewBox="0 0 24 24"
                    [attr.fill]="p.starred ? 'currentColor' : 'none'"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M12 3l2.6 5.9 6.4.6-4.9 4.5 1.5 6.3L12 17l-5.6 3.3 1.5-6.3L3 9.5l6.4-.6z"
                    />
                  </svg>
                </button>
              </div>
              <div class="pf-tile-inline">
                <span>{{ p.ccy }}</span>
                <span>{{ p.assets }}a</span>
                <span>risk {{ p.risk | number: "1.1-1" }}%</span>
                <span>{{ p.updated }}</span>
              </div>
              <div class="pf-tile-body">
                <div
                  class="pf-tile-spark"
                  [class.is-loading]="p.isLoadingSeries"
                >
                  @if (!p.isLoadingSeries) {
                    <app-sparkline
                      [data]="p.series"
                      [color]="colorFor(p)"
                      [width]="view === 'list' ? 120 : 200"
                      [height]="view === 'list' ? 24 : 36"
                    >
                    </app-sparkline>
                  }
                  @if (p.isLoadingSeries) {
                    <div
                      class="shimmer pf-tile-spark-skeleton"
                      [style.width.px]="view === 'list' ? 120 : 200"
                      [style.height.px]="view === 'list' ? 24 : 36"
                      aria-label="Loading chart"
                    ></div>
                  }
                </div>
                <div class="pf-tile-delta" [class.neg]="p.delta < 0">
                  {{ p.delta >= 0 ? "+" : "" }}{{ p.delta | number: "1.2-2" }}%
                </div>
              </div>
              <div class="pf-tile-foot">
                <div class="pf-tile-stat">
                  <div class="lbl">Risk</div>
                  <div class="val">{{ p.risk | number: "1.1-1" }}%</div>
                </div>
                <div class="pf-tile-stat">
                  <div class="lbl">Created</div>
                  <div class="val muted">{{ p.created }}</div>
                </div>
                <div class="pf-tile-stat">
                  <div class="lbl">Updated</div>
                  <div class="val muted">{{ p.updated }}</div>
                </div>
              </div>
            </a>
          }
        </div>
      }

      @if (!isLoading && hasMorePortfolios) {
        <div class="feed-load-more">
          <button
            type="button"
            class="feed-load-more-btn"
            (click)="onLoadMore()"
            [disabled]="isLoadingMore"
          >
            @if (!isLoadingMore) {
              <span>
                Load more portfolios
                <span class="feed-load-more-count"
                  >({{ remainingPortfolioCount }} remaining)</span
                >
              </span>
            }
            @if (isLoadingMore) {
              <span>Loading…</span>
            }
          </button>
        </div>
      }

      @if (isLoading) {
        <div class="home-experience__state">
          <div
            class="shimmer"
            style="
              width: 100%;
              height: 120px;
              border-radius: 14px;
              margin-bottom: 10px;
            "
          ></div>
          <div
            class="shimmer"
            style="
              width: 100%;
              height: 120px;
              border-radius: 14px;
              margin-bottom: 10px;
            "
          ></div>
          <div
            class="shimmer"
            style="width: 100%; height: 120px; border-radius: 14px"
          ></div>
        </div>
      }

      @if (!isLoading && hasError) {
        <div class="home-experience__state home-experience__state--error">
          Couldn't load portfolios. Try again in a moment.
        </div>
      }

      @if (!isLoading && !hasError && !all.length) {
        <div class="home-experience__state">
          No portfolios yet. Create one to get started.
        </div>
      }

      @if (!isLoading && !hasError && all.length && !filtered.length) {
        <div class="home-experience__state">
          No portfolios match the current filters.
        </div>
      }
    </div>
  </div>
</div>
